import React, { useCallback, useContext } from "react";
import styled from 'styled-components';
import {AudioPlayerContext} from "./AudioPlayerContext";
import { ChevronRight } from "@mui/icons-material";
import PlaylistItem from "./PlaylistItem";

export function Playlist({ children, isExpanded: [isExpanded, setIsExpanded] }) {
  const { playlistFiles, selectedFile } = useContext(AudioPlayerContext);

  const togglePlayList = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded, setIsExpanded]);

  if (!playlistFiles || playlistFiles.length === 0) return null;

  return (
    <>
      <Wrapper isExpanded={isExpanded}>
        { isExpanded ? (
          <>
            <PlaylistHeader>
              <div>Playlist</div>
              <TogglePlaylistButton onClick={togglePlayList}>
                <ChevronDownIcon fontSize="inherit" />
              </TogglePlaylistButton>
            </PlaylistHeader>
            {playlistFiles.map((file) => {
              return (
                <ItemWrapper selected={file.id === selectedFile.id} key={file.id}>
                  <PlaylistItem key={file.id} file={file} isExpanded={isExpanded}/>
                </ItemWrapper>
              )
            })}
          </>
        ): (
          <ItemWrapper>
            <PlaylistItem file={selectedFile} isExpanded={isExpanded}/>
            <TogglePlaylistButton inverted onClick={togglePlayList}>
              <ChevronUpIcon fontSize="inherit" />
            </TogglePlaylistButton>
          </ItemWrapper>
        )}
        {children}
      </Wrapper>
    </>
  )
}

const TogglePlaylistButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  color: ${({ inverted }) => inverted ? '#423F67' : 'white'};
  justify-content: center;
  align-items: center;
  font-size: 42px;
  cursor: pointer;
`;
const ChevronUpIcon = styled(ChevronRight)`
  rotate: -90deg;
`
const ChevronDownIcon = styled(ChevronRight)`
  rotate: 90deg;
`
const PlaylistHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #423F67;
  color: white;
  height: 54px;
  font-size: 16px;
  padding: 0 8px 0 16px;
  font-family: 'Quattrocento', serif;
  font-weight: bold;
`
const ItemWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  background-color: ${({ selected }) => selected ? '#E8E4DC' : 'transparent'};
  &:hover {
    background-color: #E8E4DC;
  }
`

const Wrapper = styled.div`
  z-index: 100;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  height: ${props => props.isExpanded ? 'auto' : '141px'};
  max-width: 490px;
  width: 100%;
  background-color: ${props => props.isExpanded ? '#FBF6E9' : '#E8E4DC'};
  border-top: 1px solid #CDC8C8;
  box-sizing: border-box;
  padding-top: ${props => props.isExpanded ? '0' : '0.5rem'};
  @media (max-width: 600px) {
    left: 0;
  }
`;
